/**
 *
 * Asynchronously loads the component for TakeDownListPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const TakeDownDetailPage = lazyLoad(
  () => import('./index'),
  module => module.TakeDownDetailPage,
);
